import { STRUCTURE_OPTIONS } from '../../lib/dashboard/dashboardUtils.js';
import { useApp } from '../../context/AppContext.jsx';

export function Sidebar({ adminSection }) {
  const {
    currentStructure,
    selectStructure,
    structureCounts,
    filterCollab,
    setFilterCollab,
    filterTeam,
    setFilterTeam,
    filterActivity,
    setFilterActivity,
    filterFrom,
    setFilterFrom,
    filterTo,
    setFilterTo,
    applyFilters,
    resetFilters,
    clearAllData,
    collaboratorOptions,
    activityOptions,
    teamOptions
  } = useApp();

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <div className="logo">Suivi du temps</div>
        <div className="tagline">Import CSV &amp; rapports</div>
      </div>

      <div className="sidebar-section">
        <label htmlFor="structureSelect">Structure</label>
        <select
          id="structureSelect"
          className="structure-select"
          value={currentStructure || ''}
          onChange={(e) => selectStructure(e.target.value)}
        >
          {STRUCTURE_OPTIONS.map((opt) => {
            const count = opt.id ? (structureCounts[opt.id] ?? 0) : structureCounts.all;
            return (
              <option key={opt.id || 'all'} value={opt.id}>
                {opt.label} ({count})
              </option>
            );
          })}
        </select>
      </div>

      <div className="sidebar-filters">
        {adminSection}

        <div className="filter-row">
          <label htmlFor="filterCollab">Collaborateur</label>
          <select id="filterCollab" value={filterCollab} onChange={(e) => setFilterCollab(e.target.value)}>
            <option value="">Tous</option>
            {collaboratorOptions.map((name) => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
        </div>

        <div className="filter-row">
          <label htmlFor="filterTeam">Équipe</label>
          <select id="filterTeam" value={filterTeam} onChange={(e) => setFilterTeam(e.target.value)}>
            <option value="">Toutes</option>
            {teamOptions.map((team) => (
              <option key={team} value={team}>{team}</option>
            ))}
          </select>
        </div>

        <div className="filter-row">
          <label htmlFor="filterActivity">Activité</label>
          <select id="filterActivity" value={filterActivity} onChange={(e) => setFilterActivity(e.target.value)}>
            <option value="">Toutes</option>
            {activityOptions.map((activity) => (
              <option key={activity} value={activity}>{activity}</option>
            ))}
          </select>
        </div>

        <div className="filter-row filter-row--dates">
          <div>
            <label htmlFor="filterFrom">Date début</label>
            <input id="filterFrom" type="date" value={filterFrom} onChange={(e) => setFilterFrom(e.target.value)} />
          </div>
          <div>
            <label htmlFor="filterTo">Date fin</label>
            <input id="filterTo" type="date" value={filterTo} onChange={(e) => setFilterTo(e.target.value)} />
          </div>
        </div>

        <button type="button" className="btn-apply" onClick={applyFilters}>
          Appliquer
        </button>

        <div className="sidebar-actions-row">
          <button type="button" className="btn-apply btn-apply--muted" onClick={resetFilters}>
            Réinitialiser
          </button>
          <button type="button" className="btn-apply btn-apply--danger" onClick={clearAllData}>
            Vider
          </button>
        </div>
      </div>
    </aside>
  );
}
